import {Component, EventEmitter, Output} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule} from 'ngx-dropzone-wrapper';

@Component({
    selector: 'custom-dropzone',
    templateUrl: './custom-dropzone.component.html',
    styleUrls: ['./custom-dropzone.component.css'],
    imports: [
        DropzoneModule
    ]
})
export class CustomDropzoneComponent {

    config: DropzoneConfigInterface = {
        clickable: true,
        maxFiles: 1,
        cancelReset: 1,
        errorReset: 1,
        url: '/',
        autoProcessQueue: false,
    };

    file: File | undefined;
    @Output() fileSelected = new EventEmitter<any>();

    onSelect(event: File) {
        this.file = event;
        this.fileSelected.emit(this.file);
    }
}